import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/Login',
        component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
        path: '/index',
        component: resolve => require(['@/page/index.vue'], resolve),
        redirect: '/mini_app/manage_banner',
        children: [
            //首页
            {
                path: '/home/add_banner',
                component: resolve => require(['@/page/home/add_banner.vue'], resolve)
            }, // -添加轮播图-轮播图-首页
            {
                path: '/home/home_banner',
                component: resolve => require(['@/page/home/home_banner.vue'], resolve)
            }, // 轮播图 - 首页
            {
                path: '/home/pet_diary',
                component: resolve => require(['@/page/home/pet_diary.vue'], resolve)
            }, // 宠物日历 - 首页
            {
                path: '/home/add_pet_diary',
                component: resolve => require(['@/page/home/add_pet_diary.vue'], resolve)
            }, // 添加内容 - 宠物日历 - 首页
            {
                path: '/home/pet_species',
                component: resolve => require(['@/page/home/pet_species.vue'], resolve)
            }, // 宠物品种 - 首页
            {
                path: '/home/add_species',
                component: resolve => require(['@/page/home/add_species.vue'], resolve)
            }, // 添加品种-宠物品种 - 首页
            {
                path: '/home/service_manage',
                component: resolve => require(['@/page/home/service_manage.vue'], resolve)
            }, // 服务项目管理-宠物品种 - 首页
            {
                path: '/home/add_service',
                component: resolve => require(['@/page/home/add_service.vue'], resolve)
            }, // 添加服务项目-服务项目管理-宠物品种 - 首页
            {
                path: '/home/pet_wikipedia',
                component: resolve => require(['@/page/home/pet_wikipedia.vue'], resolve)
            }, // 宠物百科- 首页
            {
                path: '/home/add_wikipedia',
                component: resolve => require(['@/page/home/add_wikipedia.vue'], resolve)
            }, //添加百科 -宠物百科- 首页
            {
                path: '/home/tail_adv',
                component: resolve => require(['@/page/home/tail_adv.vue'], resolve)
            }, //开屏广告- 首页
            {
                path: '/home/service_agreement',
                component: resolve => require(['@/page/home/service_agreement.vue'], resolve)
            }, // 服务协议- 首页
            {
                path: '/home/aboutus',
                component: resolve => require(['@/page/home/aboutus.vue'], resolve)
            }, // 关于我们- 首页
            {
                path: '/home/privacy_agreement',
                component: resolve => require(['@/page/home/privacy_agreement.vue'], resolve)
            }, // 隐私协议 首页
            //系统
            {
                path: '/set_up/role_list',
                component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
            }, // 系统角色 - 系统
            {
                path: '/set_up/add_role',
                component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
            }, // 添加角色-系统角色 - 系统
            {
                path: '/set_up/menu_list',
                component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
            }, // 系统菜单 - 系统
            {
                path: '/set_up/add_menu',
                component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/user_list',
                component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/addStaff',
                component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/order/online_order',
                component: resolve => require(['@/page/order/online_order.vue'], resolve),
                meta: {
                    keepAlive: true // 需要缓存false//不需要缓存
                }
            }, // 线上服务订单 - 订单
            {
                path: '/order/online_order_detail',
                component: resolve => require(['@/page/order/online_order_detail.vue'], resolve)
            }, // 订单详情-线上服务订单 - 订单
            {
                path: '/order/underline_order',
                component: resolve => require(['@/page/order/underline_order.vue'], resolve)
            }, // 线下服务订单 - 订单
            {
                path: '/order/underline_order_detail',
                component: resolve => require(['@/page/order/underline_order_detail.vue'], resolve)
            }, // 订单详情-线下服务订单 - 订单
            {
                path: '/order/cash_order',
                component: resolve => require(['@/page/order/cash_order.vue'], resolve)
            }, // 储蓄卡订单 - 订单
            {
                path: '/order/cash_order_detail',
                component: resolve => require(['@/page/order/cash_order_detail.vue'], resolve)
            },
            {
                path: '/order/time_order',
                component: resolve => require(['@/page/order/time_order.vue'], resolve)
            }, // 计次卡订单 - 订单
            {
                path: '/order/time_order_detail',
                component: resolve => require(['@/page/order/time_order_detail.vue'], resolve)
            }, // 查看详情-计次卡订单 - 订单
            {
                path: '/order/dis_earning',
                component: resolve => require(['@/page/order/dis_earning.vue'], resolve)
            }, // 分销收益 - 订单
            {
                path: '/order/car_order',
                component: resolve => require(['@/page/order/car_order.vue'], resolve)
            }, // 车辆订单 - 订单
            {
                path: '/order/adjust_car',
                component: resolve => require(['@/page/order/adjust_car.vue'], resolve)
            }, //调配车辆 - 车辆订单 - 订单
            {
                path: '/order/car_order_all',
                component: resolve => require(['@/page/order/car_order_all.vue'], resolve)
            }, //车辆订单汇总 - 订单
            {
                path: '/user/online_user',
                component: resolve => require(['@/page/user/online_user.vue'], resolve),
                meta: {
                    keepAlive: true // 需要缓存false//不需要缓存
                }
            }, // 线上用户 - 用户
            {
                path: '/user/look_detail',
                component: resolve => require(['@/page/user/look_detail.vue'], resolve)
            }, // 查看详情-线上用户 - 用户
            {
                path: '/user/add_user',
                component: resolve => require(['@/page/user/add_user.vue'], resolve)
            }, // 添加用户-线上用户 - 用户
            {
                path: '/user/add_pet',
                component: resolve => require(['@/page/user/add_pet.vue'], resolve)
            }, // 添加宠物-查看详情-线上用户 - 用户
            {
                path: '/user/add_adv',
                component: resolve => require(['@/page/user/add_adv.vue'], resolve)
            }, // 添加服务地址-查看详情-线上用户 - 用户
            {
                path: '/user/look_pet_detail',
                component: resolve => require(['@/page/user/look_pet_detail.vue'], resolve)
            }, // 查看宠物详情-查看详情-线上用户 - 用户
            {
                path: '/user/click_order',
                component: resolve => require(['@/page/user/click_order.vue'], resolve)
            }, // 一键下单-查看详情-线上用户 - 用户
            {
                path: '/user/sure_order',
                component: resolve => require(['@/page/user/sure_order.vue'], resolve)
            }, // 确认订单-一键下单-查看详情-线上用户 - 用户
            {
                path: '/pet/pet_list',
                component: resolve => require(['@/page/pet/pet_list.vue'], resolve)
            }, // 宠物列表 - 宠物
            {
                path: '/pet/pet_orders',
                component: resolve => require(['@/page/pet/pet_orders.vue'], resolve)
            }, // 宠物订单列表 - 宠物
            {
                path: '/pet/add_pet',
                component: resolve => require(['@/page/pet/add_pet.vue'], resolve)
            }, // 添加宠物-宠物列表 - 宠物
            {
                path: '/pet/pet_detail',
                component: resolve => require(['@/page/pet/pet_detail.vue'], resolve)
            }, // 宠物详情-宠物列表 - 宠物
            {
                path: '/pet/pet_census',
                component: resolve => require(['@/page/pet/pet_census.vue'], resolve)
            }, // 宠物统计 - 宠物
            {
                path: '/pet/pet_service',
                component: resolve => require(['@/page/pet/pet_service.vue'], resolve)
            }, // 宠物统计 - 服务项目
            {
                path: '/card/cash_card',
                component: resolve => require(['@/page/card/cash_card.vue'], resolve)
            }, // 储蓄卡 - 卡包
            {
                path: '/card/add_cash_card',
                component: resolve => require(['@/page/card/add_cash_card.vue'], resolve)
            }, // 添加储蓄卡-储蓄卡 - 卡包
            {
                path: '/card/coupon_manage',
                component: resolve => require(['@/page/card/coupon_manage.vue'], resolve)
            }, // 优惠券管理 - 卡包
            {
                path: '/card/coupon_detail',
                component: resolve => require(['@/page/card/coupon_detail.vue'], resolve)
            }, // 优惠券详情-优惠券管理 - 卡包
            {
                path: '/card/add_coupon',
                component: resolve => require(['@/page/card/add_coupon.vue'], resolve)
            }, // 添加优惠券-优惠券管理 - 卡包
            {
                path: '/card/coupon_cover',
                component: resolve => require(['@/page/card/coupon_cover.vue'], resolve)
            }, // 优惠券管理 - 卡包
            {
                path: '/worker/driver',
                component: resolve => require(['@/page/worker/driver.vue'], resolve)
            }, // 司机人员 - 工作
            {
                path: '/worker/add_driver',
                component: resolve => require(['@/page/worker/add_driver.vue'], resolve)
            }, // 添加司机人员-司机人员 - 工作
            {
                path: '/hardware/car_manage',
                component: resolve => require(['@/page/hardware/car_manage.vue'], resolve)
            }, // 车辆管理 - 硬件
            {
                path: '/hardware/add_car',
                component: resolve => require(['@/page/hardware/add_car.vue'], resolve)
            }, // 添加车辆-车辆管理 - 硬件
            {
                path: '/hardware/camera_manage',
                component: resolve => require(['@/page/hardware/camera_manage.vue'], resolve)
            }, // 摄像头管理 - 硬件
            {
                path: '/hardware/add_camrea',
                component: resolve => require(['@/page/hardware/add_camrea.vue'], resolve)
            }, // 摄像头管理 - 硬件\
            {
                path: '/hardware/add_area',
                component: resolve => require(['@/page/hardware/add_area.vue'], resolve)
            }, // 区域管理
            {
                path: '/hardware/area_manage',
                component: resolve => require(['@/page/hardware/area_manage.vue'], resolve)
            }, // 区域添加
        ]
    },
    {
        path: '/hardware/camera_video',
        component: resolve => require(['@/page/hardware/camera_video.vue'], resolve)
    }, // 摄像头列表展示
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js